import { Flex, Link, useAuthenticator, useTheme } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify";
import React from "react";

export function SignInFooter() {
    const { toResetPassword } = useAuthenticator();
    const { tokens } = useTheme();

    I18n.putVocabulariesForLanguage('en', {
        'Reset your password': 'Forgot your password?',
        'Enter your username': 'Email',
        'Send code': 'Reset my password',
        'Back to Sign In': 'Back to Login',
    });

    return (
        <Flex  padding={`0 0 ${tokens.space.medium}`}>
            <Link onClick={toResetPassword}>Reset your password</Link>
        </Flex>
    );
}
